import { render, staticRenderFns } from "./opVerifyFrameConfirmDialog.vue?vue&type=template&id=035c172f&"
import script from "./opVerifyFrameConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./opVerifyFrameConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./opVerifyFrameConfirmDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('035c172f')) {
      api.createRecord('035c172f', component.options)
    } else {
      api.reload('035c172f', component.options)
    }
    module.hot.accept("./opVerifyFrameConfirmDialog.vue?vue&type=template&id=035c172f&", function () {
      api.rerender('035c172f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/Prediction/opVerifyFrameConfirmDialog.vue"
export default component.exports